'use client';

import { useField } from "../internals/hooks/useField/index.mjs";
import { useDateTimeManager } from "../managers/index.mjs";
export const useDateTimeField = props => {
  const manager = useDateTimeManager();
  return useField({
    manager,
    props
  });
};